import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { Grid } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
    gridContainer: {
        width: '48px',
        display: 'inline-grid',
    },
    gridItem: {
        textAlign: 'center',
    }
});

class ToothCheckbox extends React.Component {

    state = {
        uppername: '',
        lowername: '',
        checkedTeeth: {},
        upperchecked: false,
        lowerchecked: false,
    };

    constructor(props){
        super(props);
        this.props=props;  
    }  

    async componentDidMount() {
        let un = '';
        let ln = '';

        if (this.props.type === 'A') {
            if (this.props.side === 'R') {
                un = '1'+this.props.label;
                ln = '3'+this.props.label;
            } else if (this.props.side === 'L') {
                un = '2'+this.props.label;
                ln = '4'+this.props.label;
            }
        } else if (this.props.type === 'C') {
            if (this.props.side === 'R') {
                un = '5'+this.props.label;
                ln = '7'+this.props.label;
            } else if (this.props.side === 'L') {
                un = '6'+this.props.label;
                ln = '8'+this.props.label;
            }
        }

        this.setState({uppername: un});
        this.setState({lowername: ln});  

        if (this.props.selectedTeeth) {

            let allChecked = this.props.selectedTeeth;

            //console.log(allChecked, allChecked[un]);

            if (allChecked[un] === true) {
                await this.setState({upperchecked: true});
            } else {
                await this.setState({upperchecked: false});
            }

            if (allChecked[ln] === true)
                await this.setState({lowerchecked: true});
            else
                await this.setState({lowerchecked: false});

            //await console.log(this.state);
        }
    }      

    handleCheckChange = pos => event => {
        let checkedArray = this.state.checkedTeeth;
        
        checkedArray[event.target.name] = event.target.checked;

        this.setState({checkedTeeth: checkedArray})

        if (pos === 'u')
            this.setState({upperchecked: event.target.checked});
        else if (pos === 'l')
            this.setState({lowerchecked: event.target.checked});
        
        this.props.changeHandle(this.props.label, this.state.checkedTeeth);
    };

    render() {
        const { classes } = this.props;

        return (
            <Grid container spacing={0} className={classes.gridContainer}>
                <Grid item xs={12} className={classes.gridItem}>
                    <Checkbox name={this.state.uppername} onChange={this.handleCheckChange('u')} checked={this.state.upperchecked} />
                </Grid>
                <Grid item xs={12} className={classes.gridItem}>
                    {this.props.label}
                </Grid>
                <Grid item xs={12} className={classes.gridItem}>
                    <Checkbox name={this.state.lowername} onChange={this.handleCheckChange('l')} checked={this.state.lowerchecked} />
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(ToothCheckbox);
